/* eslint-disable no-script-url */
import React, { useState } from "react";
import { connect } from "react-redux";
import { Button, CircularProgress } from "@material-ui/core";
import CallIcon from "@material-ui/icons/Call";
//store
import * as actions from "../../../../store/actions/actionIndex";
// uitility function
import { secToTime, maskedNumber, decryptPhoneNumber,} from "../../../../helpers/utility";

import "./styles.css";
import { useLoader } from "../../../../context/LoaderContext";
import Loading from "../../../Loading";
import CallerIdModal from "../../../../components/Modal/CallerId";

function CurrentCallInfo(props) {
  let {
    agentState,
    callType,
    rdFlag,
    callBackLive,
    isEscalation,
    custPhone,
    callDuration,
    wrapTime,
    holdTime,
    lastActivityTime,
    isHold,
    agentId,
    leadId,
    listName,
    isTransfer,
    facilityConf,
    campConf,
    skills,
  } = props;
 
  const componentId = 'ReDial';
 const {loading, showLoader} = useLoader(componentId);
 const [showModal, setShowModal] = useState(false)
 const [callerid, setCallerId] = useState("")

  callDuration = agentState === "INCALL" ? secToTime(callDuration) : "00:00:00";
  wrapTime =
    agentState === "CLOSURE" || agentState === "PREVIEW_FAIL"
      ? secToTime(lastActivityTime)
      : "00:00:00";
  holdTime = isHold === "MHOLD" ? secToTime(holdTime) : "00:00:00";

  var callTypeStr = "";
  if (rdFlag === "1") {
    callTypeStr += " (Redialed)";
  }
  if (isTransfer === "1") {
    callTypeStr += " (Transfer)";
  }
  if (callBackLive === "1") {
    callTypeStr += " (Call Back)";
  }
  if (callBackLive === "2") {
    callTypeStr += " (Abandon Callback)";
  }
  if (isEscalation === "1") {
    callTypeStr += " (Escalated)";
  }
  const values = [
    { name: "Campaign Name", value: campConf.campaign_name },
    { name: "Dialing Number", value: custPhone },
    {
      name: "Call State",
      value: agentState === "INCALL" ? "Active" : "Inactive",
    },
    // { name: "Call Type", value: agentState === "INCALL" || agentState === "CLOSURE" ? callType + (rdFlag === "1" ? "(Redialed)" : isTransfer === "1" ? "(Transfer)" : callBackLive === "1" ? "(Call Back)" : callBackLive === "2" ? "(Abandon Callback)" : isEscalation === "1" ? "(Escalated)" : "") : "" },
    {
      name: "Call Type",
      value:
        agentState === "INCALL" || agentState === "CLOSURE"
          ? callType + callTypeStr
          : "",
    },
    { name: "List Name", value: listName },
    { name: "Skills", value: skills },
    { name: "Call Time", value: callDuration },
    { name: "Hold Time", value: holdTime },
    { name: "Wrap Time", value: wrapTime },
    
  ];

  const agentDial = () => {
    showLoader();
    if(props.campConf.third_party_caller_id === "1" && props.campConf.third_party_caller_id !== null){
      setShowModal(true);
    }
  else
  {
    props.onAgentDial(agentId, custPhone, leadId, "", "", 1);
  }
  };
  const handleClose = () =>{
    setShowModal(false)
  }
  const handleCaller = (selectId) =>{
  const callerIdToUse = selectId || "";
  setCallerId(callerIdToUse)
  props.onAgentDial(agentId, custPhone, leadId, "", callerIdToUse, 1,);
   setShowModal(false)
  }
  return (
    <div className="bg-black p-20">
      {showModal && (
        <CallerIdModal isOpen = {showModal} onClose={handleClose} onCallerIdSelect = {handleCaller} phoneNumber={props.facilityConf.enable_number_mask ? (props.facilityConf.enable_number_mask === "0" ? decryptPhoneNumber(props.custPhone) : maskedNumber(props.custPhone, facilityConf.mask_start_pos, facilityConf.mask_end_pos)) : decryptPhoneNumber(props.custPhone)} />
      )}
      {values.map((post) => (
        <div className="body" key={post.name}>
          <p className="name" style={{ color: "#686D88" }}>
            {post.name}
          </p>
          {facilityConf.redial !== "1" &&
          post.name === "Dialing Number" &&
          agentState === "FREE" ? (
            post.value !== "" && (
              <p
                className="value"
                style={{ color: "#343A58", marginTop: "5px" }}
              >
                {loading ? <Loading/> :
                <Button
                  style={{
                    color: "blue",
                    height: "25px",
                    width: "100%",
                    borderColor: "blue",
                    textTransform: "capitalize",
                    textAlign: "center",
                    padding: "5px",
                  }}
                  variant="outlined"
                  textalign="center"
                  onClick={() => agentDial()}
                >
                  {props.loading ? (
                    <CircularProgress
                      size={16}
                      style={{ verticalAlign: "middle", marginInlineEnd: "10px" }}
                    />
                  ) : (
                    <CallIcon />
                  )}
                  {props.facilityConf.enable_number_mask ? (props.facilityConf.enable_number_mask === "0" ? decryptPhoneNumber(props.custPhone) : maskedNumber(post.value, facilityConf.mask_start_pos, facilityConf.mask_end_pos)) : decryptPhoneNumber(props.custPhone)}
                </Button>
}
              </p>
            )
          ) : post.name === "Dialing Number" ? (
            <p className="value" style={{ color: "#343A58" }}>
              <b>
                {props.facilityConf.enable_number_mask ? (props.facilityConf.enable_number_mask === "0" ? decryptPhoneNumber(props.custPhone) : maskedNumber(post.value, facilityConf.mask_start_pos, facilityConf.mask_end_pos)) : decryptPhoneNumber(props.custPhone)}
              </b>
            </p>
          ) : (
            <p className="value" style={{ color: "#343A58" }}>
              <b>{post.value}</b>
            </p>
          )}
        </div>
      ))}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    skills: state.agentData.skills,
    agentState: state.agentData.agentState,
    agentId: state.agentData.agentId,
    leadId: state.agentData.leadId,
    callType: state.agentData.callType,
    rdFlag: state.agentData.rdFlag,
    isTransfer: state.agentData.isTransfer,
    custPhone: state.agentData.custPhone,
    callDuration: state.agentData.callDuration,
    holdTime: state.agentData.holdTime,
    wrapTime: state.agentData.wrapTime,
    lastActivityTime: state.agentData.lastActivityTime,
    isHold: state.agentData.isHold,
    callBackLive: state.agentData.callBackLive,
    isEscalation: state.agentData.isEscalation,
    facilityConf: state.agentConfig.facilityConf,
    campConf: state.agentConfig.campConf,
    listName: state.agentData.listName,
    error: state.agentDial.error,
    loading: state.agentDial.loading,
    ivrsPath: state.agentData.ivrspath
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAgentDial: (agentId, phone, leadId, listId, callerId, redial) =>
      dispatch(actions.agentDial(agentId, phone, leadId, listId, callerId, redial)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentCallInfo);
